module.exports = __webpack_public_path__ + "img/success.54d8491.svg";